export default {
      id: "history-usage",
      viewBox: "1 1 21 21",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#history",
      toString: function () {
        return this.url;
      }
    }